export default __webpack_public_path__ + "Assets/PREMIUM/bayern/Fitnesstests für AOK.pdf";